import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-alert-diamond',
  standalone: true,
  templateUrl: '../../assets/alert-diamond.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamAlertDiamondIcon {}
